import { ReactSVG } from "react-svg";
import { Contact } from "services/api/contacts/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import ContactCell from "ui/components/Table/TableSearch/components/Cells/ContactCell";
import Badge from "ui/components/Badge/Badge";

const handleEmailClick = (e: React.MouseEvent, email: string) => {
  e.stopPropagation();
  e.preventDefault();
  window.location.href = `mailto:${email}`;
};

const handlePhoneClick = (e: React.MouseEvent, phone: string) => {
  e.stopPropagation();
  e.preventDefault();
  window.location.href = `tel:${phone}`;
};

export const WAREHOUSE_CONTACT_SEARCH_COLUMNS = (
  t: (key: string) => string,
): Column[] => [
  {
    title: "",
    key: "warehouse_contact_image",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => {
      const isCompany = row.contactType?.id === "C";
      const initials = isCompany
        ? (row.companyName ?? row.name ?? "").charAt(0).toUpperCase()
        : `${row.firstName?.charAt(0) ?? ""}${row.lastName?.charAt(0) ?? ""}`.toUpperCase();
      return <TableIcon imageUrl={row.pictures?.[0]?.url ?? null} initials={initials} />;
    },
  },
  {
    title: "Kontakt",
    key: "warehouse_contact_person",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    // Naziv s tooltipom kao u pretrazi kontakata; tvrtka nema ime i prezime, pa ContactCell uzima naziv.
    render: (row: Contact) => (
      <div className="min-w-0">
        <ContactCell contact={row} />
        {row.jobTitle && <div className="text-xs text-slate-500 truncate">{row.jobTitle}</div>}
      </div>
    ),
  },
  {
    title: "Vrsta",
    key: "warehouse_contact_type",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => {
      const isCompany = row.contactType?.id === "C";
      return (
        <Badge
          text={isCompany ? "Tvrtka" : "Osoba"}
          variant={isCompany ? "info" : "success"}
          height="small"
          showDot
        />
      );
    },
  },
  {
    title: t("admin.fleet.warehouse.detail.contact.email"),
    key: "warehouse_contact_email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => (
      <div>
        {row.primaryContactEmail ? (
          <span
            onClick={(e) => handleEmailClick(e, row.primaryContactEmail!.emailAddress)}
            className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
          >
            <ReactSVG src="/media/icons/email.svg" className="w-4 h-4 stroke-sky-500 shrink-0" />
            {row.primaryContactEmail.emailAddress}
          </span>
        ) : null}
      </div>
    ),
  },
  {
    title: t("admin.fleet.warehouse.detail.contact.phone"),
    key: "warehouse_contact_phone",
    field: "",
    type: ColumnTypes.custom,
    render: (row: Contact) => (
      <div>
        {row.primaryContactPhone ? (
          <span
            onClick={(e) => handlePhoneClick(e, row.primaryContactPhone!.phoneNumber)}
            className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
          >
            <ReactSVG src="/media/icons/phone.svg" className="w-4 h-4 stroke-sky-500 shrink-0" />
            {row.primaryContactPhone.phoneNumber}
          </span>
        ) : null}
      </div>
    ),
  },
];
